angular.module('dnecom')
    .controller('CollectionProductSearchModalController', CollectionProductSearchModalController);

CollectionProductSearchModalController.$inject = ['$scope', '$uibModalInstance', '$http', 'notifications', 'collectionItem', 'storeId'];

function CollectionProductSearchModalController($scope, $uibModalInstance, $http, notifications, collectionItem, storeId) {
    $scope.item = collectionItem;
    $scope.products = [];
    $scope.queryString = '';
    $scope.storeId = storeId;

    $scope.searchProducts = function () {
        if ($scope.queryString && $scope.queryString.length) {
            $http({
                url: Routing.generate('collection_search_products', {id: $scope.storeId, 'collectionId': $scope.item.id}),
                method: "GET",
                params: {'queryString': $scope.queryString}
            }).then(function (response) {
                $scope.products = response.data;
            }, function () {
                $scope.products = [];
            })
        }
    };

    $scope.addItem = function (item) {
        $http.post(Routing.generate('collection_add_products', {'id': $scope.storeId, 'collectionId': $scope.item.id, 'productId': item.id}))
            .then(function () {
                notifications.success('Product added to collection');
                $scope.products = _.reject($scope.products, function(el) { return el.id === item.id; });
            }, function () {
                notifications.danger('Something goes wrong');
            });
    };

    $scope.close = function () {
        $uibModalInstance.close();
    };
};


